import { AspectRatio } from "@mui/icons-material";
import StatControl from "../../HOC/StatControl";

export const TotalArea = (props) => {
    const { fullName, totalArea, saveFullApartSquare } = props;

    let textHeader = "Площадь апартамента";
    let checkedTotalArea = saveFullApartSquare === "" ? "-" : saveFullApartSquare;

    let squareNamespaces = "";

    switch (fullName) {
        case "Метраж, Доход по отелю":
            textHeader = "Площадь отеля";
            checkedTotalArea = totalArea;
            break;

        case "Метраж, Доход по категории":
            break;

        case "Метраж, Доход по апартаменту":
            break;

        default:
            break;
    }

    const prep = {
        rgbaOne: "rgba(77, 153, 168, 0.54)",
        rgbaTwo: "rgba(105, 161, 172, 0.1)",
        textHeader,
        colorOfSecondBlock: "emerald.main",
        symbol: "м²",
        textFooter: "Площадь объекта в м²",
        preStatDat: checkedTotalArea,
        squareNamespaces,
        ...props,
    };

    return (
        <StatControl prep={prep}>
            <AspectRatio color="emerald" sx={{ mr: 1 }} />
        </StatControl>
    );
};
